import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { ROLES } from "@/lib/constants";

const RoleContext = createContext({ role: ROLES[0], setRole: () => {}, roles: ROLES });

export const RoleProvider = ({ children }) => {
  const [roleId, setRoleId] = useState(() => {
    if (typeof window === "undefined") return ROLES[0].id;
    const stored = localStorage.getItem("kipkruiden-role");
    return ROLES.find((r) => r.id === stored) ? stored : ROLES[0].id;
  });

  useEffect(() => {
    localStorage.setItem("kipkruiden-role", roleId);
  }, [roleId]);

  const value = useMemo(() => {
    const role = ROLES.find((r) => r.id === roleId) || ROLES[0];
    return { role, setRole: setRoleId, roles: ROLES };
  }, [roleId]);

  return <RoleContext.Provider value={value}>{children}</RoleContext.Provider>;
};

export const useRole = () => useContext(RoleContext);
